module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Lost-Treasures-of-the-Maya.12bddd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Lost-Treasures-of-the-Maya.jpg
// module id = vvGE
// module chunks = 0